// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"22848":"b40e460191ed3f7b","30583":"2bc66d0f5711f34a","32201":"3984992d4307d434","82437":"1d4b1ea21c815759","95421":"72f523c0971f3952"}[chunkId] + ".css";
};